'use es6';

import PropTypes from 'prop-types';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
const ActionContextPropType = PropTypes.oneOf([ACTION_CONTEXTS.PURCHASE, ACTION_CONTEXTS.ANY]);
export default ActionContextPropType;